import loader from '../moduleLoader.js';
import animateScrollTo from 'animated-scroll-to';

class ScrollToTop {
    constructor(button) {
        this.button = button;
    }
    init() {
        this.button.addEventListener('click', this.scrollToTop)
    }
    scrollToTop(e) {
        animateScrollTo(0);
    }
}

loader.add('ScrollToTop', ScrollToTop);

export default ScrollToTop;